// TMessage.js - 增强版
import { Message } from 'element-ui';

class TMessage {
	static show(options) {
		const opts = {
			showClose: true,
			duration: 3000,
			...options
		};
		const instance = Message(opts);
		// Element UI 的 Message 自身定时器会被鼠标悬停 clearTimer（移开后再重新计满时长），
		// 而提示条正好出现在刚点击的导航菜单下方，鼠标停上去就会长时间不消失。
		// 这里补一个不受悬停影响的兜底定时器，保证到点必关；duration<=0 表示常驻，不做兜底
		if (instance && opts.duration > 0) {
			setTimeout(() => {
				if (!instance.closed) {
					instance.close();
				}
			}, opts.duration);
		}
		return instance;
	}

	static success(message, options = {}) {
		return this.show({
			message,
			type: 'success',
			...options
		});
	}

	static error(message, options = {}) {
		return this.show({
			message,
			type: 'error',
			...options
		});
	}

	static warning(message, options = {}) {
		return this.show({
			message,
			type: 'warning',
			...options
		});
	}

	static info(message, options = {}) {
		return this.show({
			message,
			type: 'info',
			...options
		});
	}

	static closeAll() {
		Message.closeAll();
	}
}

export default TMessage;

// 使用说明
// 在组件中使用
// import TMessage from '@/utils/TMessage'
//
// // 成功提示
// TMessage.success('操作成功')
//
// // 错误提示
// TMessage.error('操作失败')
//
// // 自定义持续时间
// TMessage.warning('警告信息', { duration: 5000 })
//
// // 关闭所有消息
// TMessage.closeAll()
